import { setWindowLocation } from '@eb/http';

import { collectionsDuck } from '@eb/redux-destination';
import {
    BROWSE_EVENTS_PATH,
    EDITORIAL_COLLECTION_PAGE_GA_CATEGORY,
    COLLECTION_PAGE_GA_CATEGORY,
    BROWSE_EVENTS_GA_ACTION,
} from '../constants';

const {
    actionTypes: { BROWSE_EVENTS },
} = collectionsDuck;

const trackBrowseEvents = (isEditorial) => ({
    type: BROWSE_EVENTS,
    meta: {
        analytics: {
            category: isEditorial
                ? EDITORIAL_COLLECTION_PAGE_GA_CATEGORY
                : COLLECTION_PAGE_GA_CATEGORY,
            action: BROWSE_EVENTS_GA_ACTION,
        },
    },
});

export const clickOnBrowseEvents = () => (dispatch, getState) => {
    const {
        collection: { isQuality },
    } = getState();

    setWindowLocation(BROWSE_EVENTS_PATH);
    dispatch(trackBrowseEvents(isQuality));
};
